import { required, helpers, minLength, maxLength } from '@vuelidate/validators';
import {
    isValidEmail,
} from './common';
import { computed } from 'vue';


export function getResetPasswordRules(t) {
    return computed(() => {
        return {
            email: {
                required: helpers.withMessage(t('ERROR_REQUIRED'), required),
                isValidEmail: helpers.withMessage(t('ERROR_EMAIL_INVALID'), isValidEmail),
                minLength: helpers.withMessage(
                    ({ $params }) => t('ERROR_MIN_LENGTH', { min: $params.min }),
                    minLength(1)
                ),
                maxLength: helpers.withMessage(
                    ({ $params }) => t('ERROR_MAX_LENGTH', { max: $params.max }),
                    maxLength(255)
                )
            },
        }
    })
}